import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Branded first-load splash: the NC Mycology badge fades/scales in over a dark backdrop,
// then the whole overlay fades away. Shows once per browser tab session.
export default function SplashScreen() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !sessionStorage.getItem("nc_splash_seen");
  });

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("nc_splash_seen", "1");
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => setShow(false), 1650);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          onAnimationComplete={() => { document.body.style.overflow = ""; }}
        >
          <div className="grain-fixed" aria-hidden="true" />
          <div className="relative flex flex-col items-center">
            <div className="absolute inset-0 rounded-full bg-primary/25 blur-[80px] scale-110" aria-hidden="true" />
            <motion.img
              src="/nc-logo.png"
              alt="NC Mycology"
              className="relative w-52 sm:w-64 h-auto object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]"
              initial={{ opacity: 0, scale: 0.86, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            />
            <motion.div
              className="mt-8 h-[2px] w-40 overflow-hidden bg-border rounded-full"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.4 }}
            >
              <motion.div
                className="h-full bg-primary"
                initial={{ x: "-100%" }}
                animate={{ x: "0%" }}
                transition={{ delay: 0.5, duration: 1.05, ease: "easeInOut" }}
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
